exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-result-price{margin:0}.ebx-result-price__original-value{color:grey;text-decoration:line-through}", ""]);
